module.exports = __webpack_public_path__ + "static/media/bubble.2055b4c7.png";